import { useRouteError } from 'react-router-dom';
import { ErrorFallback } from './ErrorFallback';

export function ErrorForwarder({ from = 'auth' }) {
	const error = useRouteError();

	// Get the actual error from React Query if available
	const queryError = error?.error || error;

	if (queryError?.status === 401 && from === 'no-auth') return window.location.reload();
	return <ErrorFallback error={queryError} resetErrorBoundary={() => window.location.reload()} />;
}
